import React, { useEffect, useState } from 'react';
import Main from './layouts/main';
import OfflineBar from './components/offline';

const App = () => {
    const [isOffline, setOffline] = useState(false)
    useEffect(() => {
        const changeStatus = (e) => {
            setOffline(e.type === "offline")
        }
        window.addEventListener("offline", changeStatus);
        window.addEventListener("online", changeStatus);
    }, [setOffline])

    return (
        <div>
            {isOffline && <OfflineBar />}
            <Main />
        </div>
    );
}

export default App;
